module.exports = __webpack_public_path__ + "img/lang-20.f516f9fc.jpg";